import React from 'react'
import { OrderListProvider } from './Context'
import { Layout } from './Layout'

export const Page = () => {
  return (
    <OrderListProvider>
      <Layout />
    </OrderListProvider>
  )
}
